export default __webpack_public_path__ + "static/media/telemarketinghelp-form.0fa2c6b9.PNG";